import { z } from 'zod';
import { ProxyPoolRotationSchema } from './proxyPoolRotationOptions';
import { ProxyPoolProtocolSchema } from './proxyPoolProtocolOptions';
import { ProxyTypeZodEnum } from './proxyType';

export const PoolDtoZod = z.object({
  id: z.number(),
  countries: z.array(z.string()).nullable(),
  pool_name: z.string(),
  subscription_id: z.number(),
  states: z.array(z.string()),
  cities: z.array(z.string()),
  rotation: ProxyPoolRotationSchema,
  protocol: ProxyPoolProtocolSchema,
  proxy_type: ProxyTypeZodEnum
});

export type PoolType = z.infer<typeof PoolDtoZod>;